<template>
    <div v-if="user_loaded">
        <GreetModal :dialog="dashboard.showInitialGreeting" />
        <AvatarModal :dialog="dashboard.showAvatarModal" v-if="dashboard.showAvatarModal" />
        <CategoriesModal :dialog="dashboard.showCategoriesModal" />
        <PrePollModal :dialog="dashboard.showFinishPreferencesModal" />
        <SurveyModal :dialog="dashboard.showInitialPoll" v-if="dashboard.showInitialPoll" />
        <FinishSurveyModal :dialog="dashboard.showFinishSurveyModal" />
        <DiagnosticTutorialModal :dialog="dashboard.showDiagnosticTutorialModal" />
        <DiagnosticModal :dialog="dashboard.mount_diagnostic" v-if="dashboard.mount_diagnostic && diagnosticData.length"/>
        <FinishOnBoarding :dialog="dashboard.showFinishOnboardingModal" />
        <v-overlay
            :absolute="false"
            :opacity="1"
            :value="showBackdrop"
            :z-index="100"
            color="#514773"
        >
        </v-overlay>
    </div>
</template>
<script>
/* eslint-disable import/no-unresolved */
import { mapState } from 'vuex'

import GreetModal from './GreetModal.vue'
import AvatarModal from './AvatarModal.vue'
import CategoriesModal from './CategoriesModal.vue'
import PrePollModal from './PrePollModal.vue'
import SurveyModal from './Survey/SurveyModal.vue'
import FinishSurveyModal from './FinishSurveyModal.vue'
import DiagnosticTutorialModal from './diagnostic/DiagnosticTutorialModal.vue'
import DiagnosticModal from './diagnostic/DiagnosticModal.vue'
import FinishOnBoarding from './FinishOnBoarding.vue'

export default {
    components: {
        GreetModal,
        AvatarModal,
        CategoriesModal,
        PrePollModal,
        SurveyModal,
        FinishSurveyModal,
        DiagnosticTutorialModal,
        DiagnosticModal,
        FinishOnBoarding
    },
    computed: {
        ...mapState({
            dashboard: (state) => state.dashboard,
            user_loaded: (state) => state.userData.user_loaded,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
        showBackdrop() {
            return (
                this.dashboard.showInitialGreeting ||
                this.dashboard.showAvatarModal ||
                this.dashboard.showCategoriesModal ||
                this.dashboard.mount_diagnostic ||
                this.dashboard.showInitialPoll ||
                this.dashboard.showFinishPreferencesModal ||
                this.dashboard.showFinishSurveyModal ||
                this.dashboard.showDiagnosticTutorialModal ||
                this.dashboard.showFinishOnboardingModal
            )
        },
    },
}
</script>
